import React from "react";
import PropTypes from "prop-types";
import useScreenBreakpoint from "@hooks/useScreenBreakpoint";
import Skeleton from "react-loading-skeleton";
import { SkeletonContainer } from "./styles";

type InProgressActivitiesSkeletonProps = {
  height: number;
  offset?: number;
};

const InProgressActivitiesSkeleton: React.FC<InProgressActivitiesSkeletonProps> = ({
  height,
  offset,
}) => {
  const { isSmallerScreens } = useScreenBreakpoint();
  const LEGEND_HEIGHT = isSmallerScreens ? 150 : 50;
  const GAP = 24;
  const CHART_HEIGHT = height + offset - GAP - LEGEND_HEIGHT;

  return (
    <SkeletonContainer>
      <Skeleton height={CHART_HEIGHT} />
      <Skeleton height={LEGEND_HEIGHT} />
    </SkeletonContainer>
  );
};

InProgressActivitiesSkeleton.propTypes = {
  height: PropTypes.number.isRequired,
  offset: PropTypes.number,
};

InProgressActivitiesSkeleton.defaultProps = {
  offset: 15,
};

export default InProgressActivitiesSkeleton;
